const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromotionsGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M446.831 213.635 256 150.378 65.169 213.635.01 317.135l59.985 19.885v110.009L255.999 512l196.004-64.971V337.02l59.985-19.885-65.157-103.5M389.33 226.18l-137.739 48.497-130.533-43.269 130.533-43.269L389.33 226.18M45.803 300.709l34.88-51.742 148.492 49.223-34.879 55.405-148.493-49.222m43.267 45.286 117.823 39.056 30.013-47.673v134.38L89.07 426.417v-76.758m177.207 125.762v-134.38l30.013 47.673 117.823-39.056v76.758l-147.836 49.005m42.61-121.825-34.879-55.405 148.491-49.223 34.881 55.406-148.493 49.222",
    style: {
      fill: "rgb(114,114,114",
      fillRule: "nonzero"
    },
    transform: "matrix(.03538 0 0 .03297 2.296 4.955)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.073 3.459C140.557 125.764 122.304 144.016 0 166.532c122.305 22.516 140.557 40.768 163.073 163.073 22.516-122.305 40.768-140.557 163.073-163.073-122.305-22.516-140.558-40.768-163.073-163.073Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "rotate(8.335 4.871 7.14) scale(.03451)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.064 232.896c-14.318 77.781-25.928 89.39-103.708 103.708 77.78 14.319 89.39 25.928 103.708 103.708 14.318-77.78 25.928-89.39 103.707-103.708-77.781-14.318-89.388-25.927-103.707-103.708Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.0354 .00518 -.00518 .0354 7.071 -6.972)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionsGray);
export default __webpack_public_path__ + "static/media/promotions_gray.355564384bc0715a6b1e9cea256dfae8.svg";
export { ForwardRef as ReactComponent };